import React from "react";
import image from '../../../images/situation/nkozijnen/aantalKozijnen.jpg'
import PropTypes from "prop-types";

Kozijnen.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function Kozijnen(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Hier kunt u invullen hoeveel kozijnen deze specifieke situatie bevat.<br/>
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier uw aantal kozijnen in..."
        />
        <img className="explainImagePhone" src={image} alt=""/>
    </div>;
}
